import { Injectable } from '@angular/core';
import { Anys } from '../../util/anys';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GestionErreurService {
  private readonly codeErreurGenerique = '[???]';

  constructor() {}

  getStatus(err: HttpErrorResponse): number {
    return err.status;
  }

  getCodeErreur(err: HttpErrorResponse): string {
    return (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      err?.error?.errors?.find((e: any) => Anys.notNullOrUndef(e.code))?.code ??
      this.codeErreurGenerique
    );
  }

  getMessageErreur(err: HttpErrorResponse): string {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return err?.error?.errors?.find((e: any) => Anys.notNullOrUndef(e.message))?.message ?? '';
  }
}
